import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './auth-interceptor';
import { ClientIdInterceptor } from './client-id-interceptor';
import { DashboardImpersonationInterceptor } from './dashboard-impersonation-interceptor';
import { DeploymentMonitorInterceptor } from './deployment-monitor.interceptor';
import { ThrottledApiCallHttpInterceptor } from './throttle-interceptor';

/** Http interceptor providers in outside-in order */
export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: DeploymentMonitorInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: ClientIdInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: DashboardImpersonationInterceptor, multi: true },
  // { provide: HTTP_INTERCEPTORS, useClass: ThrottledApiCallHttpInterceptor, multi: true },
];
